import React from 'react';

import { Modal } from 'react-bootstrap';

const ModalTitle = (props: React.HTMLAttributes<HTMLHeadingElement>): JSX.Element => <Modal.Title as="h1" {...props} />;

ModalTitle.displayName = 'ModalTitle';

export default ModalTitle;
